import type { ComposerMention } from "~vue/api/generated/chat";

export function mentionQuery(text: string, caret: number): { start: number; end: number; query: string } | null {
    const prefix = text.slice(0, caret);
    const match = /(?:^|[\s([{])@([^@\n]*)$/.exec(prefix);
    if (!match) {
        return null;
    }
    const query = match[1] ?? "";
    if (query.length > 80) {
        return null;
    }
    return { start: caret - query.length - 1, end: caret, query };
}

export function reconcileMentions(before: string, after: string, mentions: ComposerMention[]): ComposerMention[] {
    if (before === after) {
        return mentions;
    }
    let prefix = 0;
    while (prefix < before.length && prefix < after.length && before[prefix] === after[prefix]) {
        prefix++;
    }
    let suffix = 0;
    while (suffix < before.length && suffix < after.length && before[before.length - suffix - 1] === after[after.length - suffix - 1]) {
        suffix++;
    }
    const sharedLength = Math.min(before.length, after.length);
    const start = Math.min(prefix, sharedLength - suffix);
    const oldEnd = before.length - Math.min(suffix, sharedLength - prefix);
    const delta = after.length - before.length;
    return mentions
        .flatMap((mention) => {
            if (mention.end <= start) {
                return [mention];
            }
            if (mention.start >= oldEnd) {
                return [{ ...mention, start: mention.start + delta, end: mention.end + delta }];
            }
            return [];
        })
        .filter((mention) => after.slice(mention.start, mention.end) === `@${mention.label}`);
}
